import { jsx as _jsx } from "react/jsx-runtime";
import LoginComponent from "./components/LoginComponent";
function AuthPage() {
    return (_jsx("div", { className: "w-screen h-[100dvh] flex justify-center items-center backdrop-brightness-50 font-content", children: _jsx(LoginComponent, {}) }));
}
export default AuthPage;
